import { API } from 'aws-amplify';
import { TUTORING_V2_URL_APPEND } from 'constants';

export const getV2TimeBlocks = async ({
  page,
  pageSize,
  ascending,
  teacherId,
  subjectId,
  activeOnly,
  paginationKey,
}) => {
  const response = await API.get(
    'delta-api',
    `${TUTORING_V2_URL_APPEND}/timeblocks`,
    {
      queryStringParameters: {
        page,
        ascending,
        teacherId,
        subjectId,
        activeOnly,
        paginationKey,
        limit: pageSize,
      },
    },
  );

  return response;
};
